<div class="d-flex flex-column">
  <div *ngIf="proposal.proposalInformation.individualConditionsFreeText" class="d-flex proposal-details-row">
    <div class="info-col">{{'proposalDetails.individualConditions' | translate}}:</div>
    <div class="pre-wrap">{{proposal.proposalInformation.individualConditionsFreeText}}</div>
  </div>
  <div *ngIf="proposal.proposalInformation.individualClausesFreeText" class="d-flex proposal-details-row">
    <div class="info-col">{{'proposalDetails.individualClauses' | translate}}:</div>
    <div class="pre-wrap">{{proposal.proposalInformation.individualClausesFreeText}}</div>
  </div>
</div>
